module.exports = __webpack_public_path__ + "static/media/icon_read-more.8020df6d.svg";